/*
  Add here your own custom javascript codes
*/

// swiper html error fix (?)
if (!customElements.get("swiper-slider")) {
  customElements.define("swiper-slider", SwiperSliderClass);
}
try {
  customElements.define("swiper-slider", SwiperSliderClass);
} catch (e) {
  if (e.name !== "NotSupportedError") {
    throw e;
  }
  // Element is already defined, no action needed
}

document.addEventListener('DOMContentLoaded', () => {
  const desktopNavbar = document.querySelector('#navbar-desktop');
  if (!desktopNavbar) return;

  const isDesktop = () => window.innerWidth >= 992;

  const dropdownItems = desktopNavbar.querySelectorAll('.nav-item.dropdown');

  const openDropdown = (item) => {
    const toggle = item.querySelector('.dropdown-toggle');
    const menu = item.querySelector('.dropdown-menu');
    if (!toggle || !menu) return;

    dropdownItems.forEach((other) => {
      if (other !== item) closeDropdown(other);
    });

    toggle.classList.add('show');
    menu.classList.add('show');

    toggle.dispatchEvent(new Event('show.bs.dropdown', { bubbles: true }));
  };

  const closeDropdown = (item) => {
    const toggle = item.querySelector('.dropdown-toggle');
    const menu = item.querySelector('.dropdown-menu');
    if (!toggle || !menu) return;

    toggle.classList.remove('show');
    menu.classList.remove('show');

    toggle.dispatchEvent(new Event('hidden.bs.dropdown', { bubbles: true }));
  };

  dropdownItems.forEach((item) => {
    const toggle = item.querySelector('.dropdown-toggle');
    if (toggle) {
      toggle.addEventListener('click', (e) => {
        if (isDesktop()) e.preventDefault();
      });
    }

    const handleOpen = () => {
      if (isDesktop()) openDropdown(item);
    };

    const handleClose = (e) => {
      if (!isDesktop()) return;
      if (!e.relatedTarget || !item.contains(e.relatedTarget)) {
        closeDropdown(item);
      }
    };

    item.addEventListener('mouseenter', handleOpen);
    item.addEventListener('focusin', handleOpen);
    item.addEventListener('mouseleave', handleClose);
    item.addEventListener('focusout', handleClose);
  });

  desktopNavbar.addEventListener('mouseleave', () => {
    if (isDesktop()) dropdownItems.forEach(closeDropdown);
  });
});
